import React from 'react'
import './App.css';
import { CompetitionRoot } from './Competition/Root/CompetitionRoot'
import { ManagementRoot } from './Management/ManagementRoot';

/**
 * ルートコンポーネントプロパティ
 * 応募、審査、管理画面をビルド時に切り替える
 */
const Roots = {
    Competition: <CompetitionRoot/>,
    Vote: "",
    Management: <ManagementRoot/>,
}

function App (): JSX.Element {
    return (
        <div className="App">
            {/* ビルドしたい画面に応じて切り替える */}
            
            {/* KAGU登録 */}
            {Roots.Competition}

            {/* 管理画面 */}
            {/* {Roots.Management} */}
        </div>
    )
}

export default App
